<ng-container *ngIf="DataSource$ | async as DataSource">

    <div class="flex selected-input">
        <div class="relative w-full select-none">
            <form class="flex items-center" [formGroup]="form">
                <div [ngClass]="smallInput ? 'input-group input-group-sm' : 'input-group'" class="ms-input-group">
                    <!--<span class="input-group-text ms-input-icon" *ngIf="true">
                        <i class="fa-solid fa-layer-group"></i>
                    </span>-->

                    <input type="text" #Input readonly [id]="'input_' + componentId"
                        class="form-control text-only ms-input" [value]="displayString | async"
                        [placeholder]="placeholder ?? ('lib.SEARCH' | translate)" [disabled]="disabled"
                        #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="this.disabled ? null : menu"
                        (menuClosed)="onMenuClose()" (menuOpened)="onMenuOpen()"
                        [ngClass]="{'form-control-solid': solidInput, 'form-control-sm': smallInput}" />

                    <!-- Loading indicator -->
                    <div class="position-absolute input-loader"
                        [class.has-clear-btn]="selectionModel.selected.length > 0 && formControl?.enabled"
                        *ngIf="(isLoading || showPartialLoader) && !menuTrigger.menuOpen">
                        <div class="position-relative">
                            <ngx-spinner
                                [name]="multiSelectKey!"
                                class="spinner"
                                bdColor="rgba(255,255,255,0)"
                                [size]="smallInput ? 'small' : 'default'"
                                color="var(--kt-input-solid-color)"
                                type="ball-pulse"
                                [fullScreen]="false"
                            ></ngx-spinner>
                        </div>
                    </div>

                    <!-- Clear -->
                    <button *ngIf="selectionModel.selected.length > 0 && formControl?.enabled" (click)="clearSelected()"
                        class="btn btn-icon btn-sm ms-clear-btn input-group-append btn-secondary" type="button"
                        aria-label="Clear selection">
                        <i class="fa fa-xmark"></i>
                    </button>
                </div>

            </form>
        </div>
    </div>

    <!-- Menu -->
    <mat-menu #menu="matMenu" class="multiselect-menu py-2" [overlapTrigger]="false">

        <div class="ms-menu" [id]="'menu_' + componentId" (keydown)="keypressHandler($event)" [formGroup]="form">

            <!-- Search -->
            <div class="ms-search px-3 pt-3" *ngIf="showMenuFilter" (click)="$event.stopPropagation()">
                <div class="input-group input-group-sm">
                    <input type="text" #FilterInput
                        class="form-control form-control-sm form-control-solid ms-search-input" formControlName="search"
                        [placeholder]="'lib.SEARCH' | translate" />

                    <button class="btn btn-sm btn-icon ms-search-clear" type="button"
                        *ngIf="(form.controls.search.value?.length ?? 0) > 0"
                        (click)="form.controls.search.setValue(''); $event.stopPropagation();">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>

                <div class="separator separator-dashed my-3"></div>
            </div>

            <!-- List -->
            <div class="ms-list" (scroll)="scrollHandler($event)" (click)="$event.stopPropagation();">

                <!-- Loader -->
                <div class="ms-loader" *ngIf="isLoading">
                    <span class="spinner-border spinner-border-sm text-primary me-2" role="status"></span>
                    <span class="text-muted">A carregar…</span>
                </div>


                <ng-container *ngIf="!isLoading">
                    <ng-container *ngFor="let itemLabel of itemLabels">

                        <!-- GROUP -->
                        <div class="ms-group" *ngIf="(itemLabel.children?.length ?? 0) > 0">

                            <mat-expansion-panel class="ms-panel" [expanded]="itemLabel.open" [hideToggle]="false"
                                [disabled]="false">

                                <mat-expansion-panel-header class="ms-group-header"
                                    [class.is-checked]="itemLabel.checked"
                                    [class.is-indeterminate]="itemLabel.indeterminate">

                                    <div class="ms-row">
                                        <label *ngIf="selectableParents"
                                            class="form-check form-check-sm form-check-custom form-check-solid ms-check">
                                            <input class="form-check-input" type="checkbox"
                                                [checked]="itemLabel.checked" [indeterminate]="itemLabel.indeterminate"
                                                (click)="$event.stopPropagation()"
                                                (change)="toggleSelection(itemLabel)" />
                                        </label>

                                        <ng-container *ngIf="showGroupAvatar; else parentInitials">
                                            <ng-container
                                                *ngIf="getAvatarSrcFromRaw(itemLabel.raw, groupAvatarField ?? avatarField) as av; else parentInitials">
                                                <img class="ms-avatar-img" [src]="av" alt="" />
                                            </ng-container>
                                        </ng-container>

                                        <ng-template #parentInitials>
                                            <div class="ms-avatar" *ngIf="showInitials">
                                                {{ initials(itemLabel.description | translate) }}
                                            </div>
                                        </ng-template>

                                        <div class="ms-title">
                                            <span #parentText class="fw-semibold text-gray-800 ms-ellipsis"
                                                [matTooltip]="(itemLabel.description | translate)"
                                                [matTooltipDisabled]="!isTruncated(parentText)"
                                                matTooltipPosition="right"
                                                [ngClass]="itemLabel.style">
                                                <i *ngIf="itemLabel.icon" class="fas me-2"
                                                    [ngClass]="'fa-fw fa-' + itemLabel.icon"></i>
                                                {{ itemLabel.description | translate }}
                                            </span>

                                            <span class="text-dark small ms-count">
                                                {{ (itemLabel.children?.length ?? 0) }}
                                            </span>
                                        </div>

                                        <!--<i class="fa-solid fa-check text-success ms-selected-icon me-5"
                                            *ngIf="itemLabel.checked"></i>-->
                                    </div>
                                </mat-expansion-panel-header>

                                <ng-template matExpansionPanelContent>
                                    <div class="ms-children">
                                        <div *ngFor="let childLabel of itemLabel.children" class="ms-item" [ngClass]="{'no-pointer': parentItemsAsMainSelection}"
                                            [class.is-selected]="childLabel.checked"
                                            (click)="toggleSelection(itemLabel, childLabel, $event);">

                                            <label
                                                class="form-check form-check-sm form-check-custom form-check-solid ms-check">
                                                <input class="form-check-input" type="checkbox" *ngIf="!parentItemsAsMainSelection"
                                                    [checked]="childLabel.checked" (click)="$event.stopPropagation()"
                                                    (change)="toggleSelection(itemLabel, childLabel)" />
                                            </label>

                                            <ng-container *ngIf="showChildAvatar; else childInitials">
                                                <ng-container
                                                    *ngIf="getAvatarSrcFromRaw(childLabel.raw, avatarField) as cav; else childInitials">
                                                    <img class="ms-avatar-img ms-avatar-img-sm" [src]="cav" alt="" />
                                                </ng-container>
                                            </ng-container>

                                            <ng-template #childInitials>
                                                <div class="ms-avatar ms-avatar-sm" *ngIf="showInitials">
                                                    {{ initials(childLabel.description | translate) }}
                                                </div>
                                            </ng-template>


                                            <div class="ms-title">
                                                <span #childText class="text-gray-800 ms-ellipsis"
                                                    [matTooltip]="(childLabel.description | translate)"
                                                    [matTooltipDisabled]="!isTruncated(childText)"
                                                    matTooltipPosition="right"
                                                    [ngClass]="childLabel.style">
                                                    <i *ngIf="childLabel.icon" class="fas me-2"
                                                        [ngClass]="'fa-fw fa-' + childLabel.icon"></i>
                                                    {{ childLabel.description | translate }}
                                                </span>

                                            </div>

                                            <i class="fa-solid fa-check text-success ms-selected-icon"
                                                *ngIf="childLabel.checked"></i>
                                        </div>
                                    </div>
                                </ng-template>

                            </mat-expansion-panel>
                        </div>

                        <!-- SINGLE ITEM -->
                        <div class="ms-item" *ngIf="(itemLabel.children?.length ?? 0) == 0"
                            [class.is-selected]="itemLabel.checked"
                            (click)="toggleSelection(itemLabel, undefined, $event)">

                            <label class="form-check form-check-sm form-check-custom form-check-solid ms-check">
                                <input class="form-check-input" type="checkbox" [checked]="itemLabel.checked"
                                    (click)="$event.stopPropagation()"
                                    (change)="toggleSelection(itemLabel, undefined)" />
                            </label>



                            <ng-container *ngIf="showChildAvatar; else singleInitials">
                                <ng-container
                                    *ngIf="getAvatarSrcFromRaw(itemLabel.raw, avatarField) as sav; else singleInitials">
                                    <img class="ms-avatar-img ms-avatar-img-sm" [src]="sav" alt="" />
                                </ng-container>
                            </ng-container>

                            <ng-template #singleInitials>
                                <div class="ms-avatar ms-avatar-sm" *ngIf="showInitials">
                                    {{ initials(itemLabel.description | translate) }}
                                </div>
                            </ng-template>

                            <span #parentText class="fw-semibold text-gray-800 ms-ellipsis"
                                [matTooltip]="(itemLabel.description | translate)"
                                [matTooltipDisabled]="!isTruncated(parentText)" 
                                matTooltipPosition="right" [ngClass]="itemLabel.style">
                                <i *ngIf="itemLabel.icon" class="fas me-2" [ngClass]="'fa-fw fa-' + itemLabel.icon"></i>
                                {{ itemLabel.description | translate }}
                            </span>

                            <i class="fa-solid fa-check text-success ms-selected-icon" *ngIf="itemLabel.checked"></i>
                        </div>

                    </ng-container>
                </ng-container>

                <!-- Partial Loader -->
                <div class="ms-loader" *ngIf="showPartialLoader">
                    <span class="spinner-border spinner-border-sm text-primary me-2" role="status"></span>
                    <span class="text-muted">A carregar mais…</span>
                </div>


                <!-- Empty -->
                <div class="ms-empty px-3 py-4 text-center text-muted"
                    *ngIf="DataSource.body?.length === 0 && (!isLoading)">
                    {{ "lib.NO_RECORD_FOUND" | translate }}
                </div>
            </div>
        </div>
    </mat-menu>

</ng-container>